import { Injectable } from '@angular/core';
import { FinancialApiService } from 'src/app/revenue/shared/financial-api.service';
import { PagedResultGeneric } from 'src/app/shared';
import { PledgeCampaignSearchDto } from './dto/pledge-campaign-search.dto';
import { PledgeCampaignDto } from './dto/pledge-campaign.dto';
@Injectable({
  providedIn: 'root',
})
export class PledgeCampaignService {
  public constructor(private _apiService: FinancialApiService) {}

  public searchPledgeCampaigns(seachParams: PledgeCampaignSearchDto): Promise<PagedResultGeneric<PledgeCampaignDto>> {
    return this._apiService.post('/financial/v2/pledgecampaign/search', seachParams);
  }

  public getPledgeCampaign(campaignId: number) {
    return this._apiService.get(`/financial/v2/pledgecampaign/${campaignId}`);
  }

  public createPledgeCampaign(campaign: PledgeCampaignDto): Promise<number> {
    return this._apiService.post('/financial/v2/pledgecampaign', campaign);
  }

  public updatePledgeCampaign(campaign: PledgeCampaignDto) {
    return this._apiService.put(`/financial/v2/pledgecampaign`, campaign);
  }

  public deletePledgeCampaign(campaignId: number) {
    return this._apiService.delete(`/financial/v2/pledgecampaign/${campaignId}`);
  }
}
